import { calc } from '../../api/calc';
import { IframeWindow } from './index';

export class Calc implements calc.Api {
  constructor(private iframe: IframeWindow) {}

  evaluatePaths(request: calc.EvaluatePathsRequest): Promise<calc.PathResult[]> {
    return this.iframe.twoWayCall<calc.EvaluatePathsRequest, calc.PathResult[]>(
      request,
      (requestId, request) => {
        this.iframe.postMessage({
          command: 'calc.evaluatePaths',
          args: {
            ...request,
            requestId,
          },
        });
      },
      (response) => {
        let responseData;
        try {
          responseData = JSON.parse(response);
        } catch (e) {
          // Unable to parse response => response is not a stringify object
          responseData = response;
        }
        return responseData;
      }
    );
  }
}
